import { Grid, Typography } from '@mui/material';
import { CiCircleInfo } from 'react-icons/ci';
import { ICandidate } from 'wisestep-api';
import {
  WsTypography,
  WsCheckboxList,
  WsTypoVariants,
  WsColors,
  WsIconText,
  WsTypoColors,
} from 'wisestep-base';

interface MergeProfilesProps {
  currentCandidate?: ICandidate;
  mergeCandidate?: ICandidate;
}
const MergeProfiles = ({ currentCandidate, mergeCandidate }: MergeProfilesProps) => {
  return (
    <Grid container direction="row" sx={{ bgcolor: WsColors.BorderGrey }} spacing={1}>
      <Grid item xs={12} p={1} ml={2}>
        <WsIconText
          text={
            'Only 3 Emails and Phone numbers can be selected. Unselected details will be deleted'
          }
          icon={<CiCircleInfo size={20} />}
          onClick={() => {}}
        />
      </Grid>
      <Grid item xs={6}>
        {currentCandidate && <ProfileDetails candidate={currentCandidate} />}
      </Grid>
      <Grid item xs={6}>
        {mergeCandidate && <ProfileDetails candidate={mergeCandidate} />}
      </Grid>
    </Grid>
  );
};

export default MergeProfiles;

export interface ICheckBoxListOptions {
  [key: string]: string;
}
const ProfileDetails = ({ candidate }: { candidate: ICandidate }) => {
  const emails: ICheckBoxListOptions = {
    [candidate?.email ?? '']: candidate?.email ?? '',
  };
  candidate?.alternateEmails?.forEach((email) => (emails[email] = email as string));
  const phoneNums: ICheckBoxListOptions = {
    [candidate.phoneNumber ?? '']: candidate.phoneNumber ?? '',
  };
  candidate?.alternatePhoneNumbers?.forEach((email) => (phoneNums[email] = email as string));

  return (
    <Grid container p={2} sx={{ bgcolor: WsColors.White }} rowSpacing={1.5}>
      <Grid item xs={12} display="flex">
        <Typography variant="h5">{candidate.name}</Typography>
      </Grid>
      <Grid item xs={12}>
        <WsTypography variant={WsTypoVariants.SUB_TITLE}>Email</WsTypography>
        <WsTypography variant={WsTypoVariants.CAPTION} color={WsTypoColors.TERTIARY}>
          Choose Email For Merging
        </WsTypography>
        <WsCheckboxList name={'email'} options={emails} />
      </Grid>
      <Grid item xs={12}>
        <WsTypography variant={WsTypoVariants.SUB_TITLE}>Phone No</WsTypography>
        <WsTypography variant={WsTypoVariants.CAPTION} color={WsTypoColors.TERTIARY}>
          Choose Phone No for merging
        </WsTypography>
        <WsCheckboxList name={`phone`} options={phoneNums} />
      </Grid>
      {((candidate?.profileURLs && candidate?.profileURLs?.length > 0) ||
        (candidate?.socialUrls && candidate?.socialUrls?.length > 0)) && (
        <Grid item xs={12}>
          <WsTypography variant={WsTypoVariants.SUB_TITLE}>LinkedIn URL</WsTypography>
          <WsTypography variant={WsTypoVariants.CAPTION} color={WsTypoColors.TERTIARY}>
            Choose LinkedIn for merging
          </WsTypography>
          {candidate?.profileURLs && candidate?.profileURLs?.length > 0 && (
            <WsCheckboxList
              name={`profile`}
              options={{
                [candidate?.profileURLs?.[0] ?? '']: candidate?.profileURLs?.[0] ?? '',
              }}
            />
          )}
          {candidate?.socialUrls && candidate?.socialUrls?.length > 0 && (
            <WsCheckboxList
              name={`profile`}
              options={{
                [candidate?.socialUrls?.[0] ?? '']: candidate?.socialUrls?.[0] ?? '',
              }}
            />
          )}
        </Grid>
      )}
    </Grid>
  );
};
